import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import "../pd-order-contacts.js";
import { LitElement, css, html } from "lit";
import { property } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import "@progressive-development/pd-price/pd-pricetable";
import "@progressive-development/pd-content/pd-edit-content";
//#region src/pd-order-summary/PdOrderSummary.ts
var PdOrderSummary = class PdOrderSummary extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.orderSteps = [];
		this.withPayment = false;
	}
	static {
		this.styles = [css`
      :host {
        display: block;
      }
      h3 {
        color: var(--pd-default-font-title-col);
        font-family: var(--pd-default-font-title-family);
        font-size: 1.5em;
      }
      .edit-summary-container {
        display: flex;
        flex-flow: column;
        flex-wrap: wrap;
        gap: 1em;
      }
      .payment {
        margin-top: 30px;
        padding: 5px;
        background-color: var(
          --pd-order-summary-payment-bg-col,
          var(--pd-default-light-col)
        );
      }
      .pay-logo-box {
        display: flex;
      }
      .pay-logo {
        max-width: 6rem;
      }
      .pricetable {
        padding-top: 20px;
      }
      @media (max-width: 380px) {
        .pay-logo {
          max-width: 5rem;
        }
      }
    `];
	}
	firstUpdated() {
		this.addEventListener("edit-content", (e) => {
			this.dispatchEvent(new CustomEvent("go-to", {
				detail: { step: e.detail.step },
				bubbles: true,
				composed: true
			}));
		});
	}
	render() {
		if (!this.order) return html`<p>No order is set</p>`;
		return html`
      <div class="edit-summary-container">
        ${this.orderSteps.map((step, index) => this._mapOrderStepSummary(step, index))}
      </div>

      ${this.order.priceData ? html`
              <div class="payment">
                <h3>${msg("Rechnung", { id: "pd.order.summary.billing" })}</h3>
                <pd-pricetable
                  class="pricetable"
                  .priceData="${this.order.priceData}"
                ></pd-pricetable>
              </div>
            ` : ""}

      <slot name="agreement"></slot>
    `;
	}
	_mapOrderStepSummary(step, index) {
		const custom = this._renderCustomOrderStepSummary(step, index);
		if (custom) return custom;
		return html`
      <pd-edit-content
        contentTitle="${step.name}"
        stepNumber="${index + 1}"
        .data="${step.data}"
      >
        <slot name="${step.key}"></slot>
      </pd-edit-content>
    `;
	}
	_renderCustomOrderStepSummary(step, index) {
		switch (step.key) {
			case "contacts": return this._getContactsSummary(index + 1, step);
			default: return null;
		}
	}
	_getContactsSummary(index, step) {
		const contactData = this.order?.contacts;
		return html`
      <pd-edit-content contentTitle="${step.name}" stepNumber="${index}">
        ${contactData ? html`
                <pd-order-contacts
                  ?withPayment="${this.withPayment}"
                  .orderContact="${contactData.orderContact}"
                  .billingContact="${contactData.billingContact}"
                  .adminContact="${contactData.adminContact}"
                  .propertyContact="${contactData.propertyContact}"
                  summary
                ></pd-order-contacts>
              ` : ""}
      </pd-edit-content>
    `;
	}
};
__decorate([property({ type: Array })], PdOrderSummary.prototype, "orderSteps", void 0);
__decorate([property({ type: Boolean })], PdOrderSummary.prototype, "withPayment", void 0);
__decorate([property({ type: Object })], PdOrderSummary.prototype, "order", void 0);
PdOrderSummary = __decorate([localized()], PdOrderSummary);
//#endregion
export { PdOrderSummary };
